var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onSubmit($event)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "title-container", style: { background: "#FDB714" } },
          [
            _c("h2", { staticClass: "search-title" }, [
              _vm._v(
                _vm._s(_vm.searchboxheadlinerebooking[_vm.getCurrentLocale])
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale])
              ),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "soap-icon-search" }),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticStyle: { "padding-top": "20px", "background-color": "#fff" },
            attrs: { id: "content" },
          },
          [
            _c("div", { attrs: { id: "main" } }, [
              _c(
                "div",
                {
                  staticClass: "contact-address block",
                  staticStyle: {
                    "margin-left": "20px",
                    "margin-right": "20px",
                  },
                },
                [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.hellotext1[_vm.getCurrentLocale])),
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.hellotext2[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.hellotext3[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("h5", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.when[_vm.getCurrentLocale])),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-6" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.form_bookingno[_vm.getCurrentLocale]) +
                            ":* "
                        ),
                        _c("small"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.input_bookingno,
                            expression: "input_bookingno",
                          },
                        ],
                        staticClass: "input-text full-width",
                        class: { invalid: _vm.$v.input_bookingno.$error },
                        staticStyle: { "text-transform": "uppercase" },
                        attrs: {
                          type: "text",
                          id: "'input_bookingno",
                          name: "input_bookingno",
                          value: "",
                          placeholder: "E.G.: MB4K2VUH",
                        },
                        domProps: { value: _vm.input_bookingno },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.input_bookingno = $event.target.value
                            },
                            function ($event) {
                              _vm.$v.input_bookingno.$touch()
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.input_bookingno.$dirty &&
                      !_vm.$v.input_bookingno.required
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(_vm.errmsg_required[_vm.getCurrentLocale])
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input_bookingno.$dirty &&
                      !_vm.$v.input_bookingno.minLength
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errmsg_min_bookingno[_vm.getCurrentLocale]
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input_bookingno.$dirty &&
                      !_vm.$v.input_bookingno.maxLength
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errmsg_max_bookingno[_vm.getCurrentLocale]
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input_bookingno.$dirty &&
                      !_vm.$v.input_bookingno.lettersandnumbers
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errmsg_lettersandnumbers[
                                  _vm.getCurrentLocale
                                ]
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-6" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.form_birthdate[_vm.getCurrentLocale]) +
                            ":* "
                        ),
                        _c("small"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.input_birthdate,
                            expression: "input_birthdate",
                          },
                        ],
                        staticClass: "input-text full-width",
                        class: { invalid: _vm.$v.input_birthdate.$error },
                        attrs: {
                          type: "text",
                          id: "'input_birthdate",
                          name: "input_birthdate",
                          value: "",
                          placeholder: "E.G.: 01.01.1984",
                        },
                        domProps: { value: _vm.input_birthdate },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.input_birthdate = $event.target.value
                            },
                            function ($event) {
                              _vm.$v.input_birthdate.$touch()
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.input_birthdate.$dirty &&
                      !_vm.$v.input_birthdate.required
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(_vm.errmsg_required[_vm.getCurrentLocale])
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input_birthdate.$dirty &&
                      !_vm.$v.input_birthdate.minLength
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errmsg_min_birthdate[_vm.getCurrentLocale]
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input_birthdate.$dirty &&
                      !_vm.$v.input_birthdate.maxLength
                        ? _c("p", { staticClass: "errormsg" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errmsg_max_birthdate[_vm.getCurrentLocale]
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "p-check",
                    {
                      staticClass: "p-svg p-round p-pulse",
                      attrs: { color: "success", value: "ABB" },
                      model: {
                        value: _vm.checkedBoxes,
                        callback: function ($$v) {
                          _vm.checkedBoxes = $$v
                        },
                        expression: "checkedBoxes",
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "svg svg-icon",
                          attrs: { slot: "extra", viewBox: "0 0 20 20" },
                          slot: "extra",
                        },
                        [
                          _c("path", {
                            staticStyle: { stroke: "white", fill: "white" },
                            attrs: {
                              d: "M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "skin-color",
                      staticStyle: { "font-size": "1.0833em" },
                    },
                    [_vm._v(_vm._s(_vm.checkboxtext[_vm.getCurrentLocale]))]
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  !_vm.checkValidity() &&
                  _vm.get_FlagRebookingBookingnoLoginIsReadyForLogin === false
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "button btn-large uppercase full-width silver",
                        },
                        [_vm._v(_vm._s(_vm.getbookinno[_vm.getCurrentLocale]))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkValidity() &&
                  _vm.get_FlagRebookingBookingnoLoginIsReadyForLogin === true
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn-large icon-check-rebooking uppercase full-width",
                          class: {
                            sundairsrvcs: _vm.modulo === "services",
                            "icon-check3": _vm.modulo === "services",
                          },
                          style: { background: "#FDB714" },
                          attrs: { type: "submit" },
                        },
                        [_vm._v(_vm._s(_vm.getbookinno[_vm.getCurrentLocale]))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }